export const pageTitle = 'Riverside Church Burton';
export const pageDescription = 'Riverside is a family-friendly church in the middle of Burton, with a ❤️ for being Jesus in our community.';